export const typeGroups = [
    {
        header: 'The Essentials',
        types: [
            { type: 'link', icon: 'fas fa-link-simple', label: 'Link' },
            { type: 'pdf', icon: 'fas fa-file-pdf', label: 'PDF' },
            { type: 'review-link', icon: 'far fa-list-ul', label: 'Review Link' },
            { type: 'survey', icon: 'far fa-square-poll-vertical', label: 'Liquid Feedback' },
            { type: 'tracker', icon: 'fas fa-clipboard-list-check', label: 'Tracker' },
            { type: 'microsite', icon: 'fas fa-square-list', label: 'Microsite' },
        ],
    },
    {
        header: 'Popular',
        types: [
            { type: 'workout-log', icon: 'fas fa-person-walking', label: 'Workout Log' },
            { type: 'vehicle-log', icon: 'far fa-car-side', label: 'Vehicle Log' },
            { type: 'bitsignal', icon: 'fak fa-bitsignal', label: 'BitSignal' },
            { type: 'menu-pdf', icon: 'fas fa-fork-knife', label: 'Menu PDF' },
            { type: 'brochure', icon: 'fas fa-file', label: 'Brochure' },
            { type: 'user-manual', icon: 'far fa-book', label: 'User Manual' },
            { type: 'menu-link', icon: 'fas fa-fork-knife', label: 'Menu Link' },
        ],
    },
    {
        header: 'Surveys & Feedback',
        types: [
            { type: 'review', icon: 'fas fa-star-sharp-half-stroke', label: 'Review Survey' },
            { type: 'google-review', icon: 'fa-brands fa-google', label: 'Google Review' },
            { type: 'contact-form', icon: 'fas fa-address-book', label: 'Contact Form' },
        ],
    },
    {
        header: 'Trackers & Logs',
        types: [
            { type: 'service-log', icon: 'far fa-table-list', label: 'Service Log' },
            { type: 'maintenance-tracker', icon: 'far fa-screwdriver-wrench', label: 'Maintenance Tracker' },
            { type: 'inventory', icon: 'fas fa-warehouse-full', label: 'Inventory' },
            { type: 'assets', icon: 'fas fa-shelves', label: 'Assets' },
          ],
        },
        {
          header: 'Labels & Cards',
          types: [
            { type: 'liquid-label', icon: 'fas fa-tag', label: 'Liquid Label' },
			{ type: 'liquid-poster', icon: 'far fa-sheet-plastic', label: 'Liquid Poster' },
            { type: 'for-sale', icon: 'fa-solid fa-barcode-read', label: 'For Sale' },
            { type: 'container-label', icon: 'far fa-tag', label: 'Container Label' },
            { type: 'dbc', icon: 'fak fa-bitsignal', label: 'Digital Business Card' },
            { type: 'garden-label', icon: 'fas fa-leaf', label: 'Garden Label' }
        ],
    },
    {
        header: 'Microsites & Pages',
        types: [
            { type: 'landing-page', icon: 'fas fa-browser', label: 'Landing Page' },
            { type: 'connect', icon: 'fa-solid fa-airplay', label: 'QR Connect' },
        ],
    },
    {
        header: 'Social & Media',
        types: [
            { type: 'youtube', icon: 'fa-brands fa-youtube', label: 'YouTube' },
            { type: 'tiktok', icon: 'fa-brands fa-tiktok', label: 'TikTok' },
            { type: 'linkedin', icon: 'fa-brands fa-linkedin', label: 'LinkedIn' },
        ],
    },
    {
        header: 'Other',
        types: [
            { type: 'location', icon: 'fas fa-map-location', label: 'Location' },
            { type: 'appointment', icon: 'fas fa-calendar-days', label: typeof window !== 'undefined' && window.innerWidth > 480 ? 'Appointment' : 'Appt.' },
        ],
    },
];
